import React from "react";

const Footer = () => (
  <footer>
    <p>Copyright &copy; 2021 | Code and design by Deniz Halimi</p> &nbsp;
    <p>
      Powered by{" "}
      <a href="https://www.themoviedb.org/documentation/api">THE MOVIE DB</a>.
    </p>
  </footer>
);

export default Footer;
